export type NameListArray = {
  [key: string]: string;
};

export function nameListToArray(nameListArray: Record<string, { value: string }>): NameListArray[] {
  const parsedPopularSearches = Object.values(nameListArray)
    .flat()
    .map((entry) => entry.value)
    .map((value) => new URLSearchParams(value as string));
  const result: NameListArray[] = [];

  parsedPopularSearches.forEach((param) => {
    const entriesIterator = param.entries();
    const entriesArray: NameListArray = {};

    for (const pair of entriesIterator) {
      entriesArray[pair[0]] = pair[1];
    }
    result.push(entriesArray);
  });

  return result;
}
